// Utilitaire pour gérer le scroll smooth vers les sections
export const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  }
};

// Gestionnaire d'événement pour les liens internes
export const handleSmoothScroll = (e, sectionId) => {
  e.preventDefault();
  scrollToSection(sectionId);
};
